var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "bfece005-edd9-4772-884e-655a82951ada"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a5c631b0-e97e-4cc7-92a8-e5ada3fa2ae2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2 0 0 2 536.32 544.08)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 -0.1 0.25 -211)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5002.5, -7909.5)",
    d: "M 4619 8117 C 4418 8000 4093 7813 3896 7700 L 3540 7495 L 3985 7492 L 4429 7490 L 4657 7621 C 4783 7693 4911 7768 4942 7787 L 4999 7821 L 5285 7655 L 5572 7490 L 6018 7490 L 6465 7490 L 6200 7643 C 5313 8157 5011 8330 4999 8329 C 4991 8329 4820 8234 4619 8117 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 -0.1 -80.6 55.53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4194, -5244.2)",
    d: "M 2720 7216 C 2720 7214 2780 7110 2853 6984 L 2985 6755 L 3387 6752 L 3788 6750 L 4023 6342 C 4152 6118 4449 5604 4682 5200 C 4916 4796 5112 4455 5119 4442 C 5130 4421 5125 4407 5070 4309 C 5036 4249 5005 4200 5001 4200 C 4997 4200 4692 4722 4324 5360 L 3655 6520 L 3387 6520 L 3118 6520 L 3138 6488 C 3149 6470 3317 6178 3513 5840 C 3708 5502 4026 4951 4220 4615 C 4413 4280 4667 3840 4784 3638 C 4900 3436 4997 3270 5000 3270 C 5003 3270 5154 3529 5336 3845 L 5668 4420 L 5080 5437 C 4757 5997 4394 6626 4273 6835 L 4054 7215 L 3387 7218 C 3020 7219 2720 7218 2720 7216 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 -0.1 79.95 -14.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-5799.5, -5940)",
    d: "M 4331 7198 C 4338 7185 4442 7004 4563 6795 C 4683 6586 4828 6335 4884 6238 L 4985 6061 L 5531 6058 L 6077 6055 L 5941 5818 C 5866 5688 5802 5584 5798 5586 C 5794 5589 5760 5644 5723 5710 L 5655 5830 L 5386 5830 L 5118 5830 L 5132 5808 C 5140 5795 5292 5532 5471 5223 C 5649 4913 5798 4660 5801 4660 C 5804 4660 5949 4906 6123 5208 C 6296 5509 6537 5926 6658 6135 L 6877 6515 L 6066 6518 L 5254 6520 L 5192 6629 C 5158 6689 5130 6740 5130 6744 C 5130 6747 5552 6750 6069 6750 C 6808 6750 7010 6753 7018 6763 C 7030 6777 7280 7210 7280 7216 C 7280 7218 6614 7220 5800 7220 L 4319 7220 L 4331 7198 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 -0.1 -138.25 70.2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-3617.54, -5097.49)",
    d: "M 2888 5518 C 2890 5054 2894 4672 2898 4668 C 2906 4660 3131 4529 3815 4135 C 4410 3792 4355 3822 4339 3852 C 4280 3965 3915 4588 3901 4600 C 3892 4608 3759 4687 3607 4775 L 3330 4935 L 3330 5268 L 3330 5602 L 3120 5965 C 3005 6165 2907 6335 2904 6344 C 2901 6353 2895 6360 2891 6360 C 2888 6360 2886 5981 2888 5518 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1 0 0 -0.1 138.14 70.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6381.37, -5094)",
    d: "M 7096 6338 C 7088 6325 6989 6154 6876 5958 L 6670 5601 L 6670 5268 L 6670 4934 L 6383 4768 L 6095 4602 L 5892 4254 C 5780 4062 5680 3888 5669 3866 L 5648 3828 L 5707 3861 C 5971 4011 7097 4663 7102 4668 C 7108 4674 7119 6360 7113 6360 C 7111 6360 7104 6350 7096 6338 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e5577125e9c7a8cedeec0f8741980af4.svg";
export { ForwardRef as ReactComponent };